<template>
<body class="body-3">
  <div class="div-block-16">
    <div class="w-dyn-list">
      <div class="w-dyn-items">
        <div class="w-dyn-item">
          <router-link to="/shop" class="w-inline-block"><img src="../../assets/images/icon---back-arrow.png" alt="">
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <div class="div-block-11">

    <div class="div-block-13 a"><img :src="productImage" alt="" class="image-6-copy">

      <div class="w-embed"></div>

      <div class="div-block-14">
        <h2 class="heading-8">{{ this.productData.productTitle }}</h2>
        <div class="text-block-5">${{ this.productData.price }} USD</div>
        <div>
          <form @submit.prevent="" class="w-commerce-commerceaddtocartform">
            <div v-if="productData.sizeType != 'OS'" class="button-wrapper">
              <span @click="selectedSize = 'S'" href="#" class="button-15 small w-button" :class="{'selected-size': selectedSize == 'S'}">S</span>
              <span @click="selectedSize = 'M'" href="#" class="button-15 medium w-button" :class="{'selected-size': selectedSize == 'M'}">M</span>
              <span @click="selectedSize = 'L'" href="#" class="button-15 large w-button" :class="{'selected-size': selectedSize == 'L'}">L</span>
              <span @click="selectedSize = 'XL'" href="#" class="button-15 extra-large w-button" :class="{'selected-size': selectedSize == 'XL'}">XL</span>
              <!-- <a @click="selectedSize = 'os'" href="#" class="button-15 extra-larges w-button" :class="{'selected-size': selectedSize == 'os'}">OS</a> -->
            </div>
            <div role="group" style="margin-top: 30px">
              <div role="group">
                <label>Style</label>
                <select v-model="selectedStyle" class="select-field-3 w-select" required="" autocomplete="off">
                  <!-- <option :value="null" selected="">Select Size</option> -->
                  <option v-for="(style,index) in styles" :value="style.value || style">{{style.text || style}}</option>

                </select>
              </div>
            </div>
            <!--<div class="text-block-3">Statue of Liberty Baltoro Jacket</div>-->
            <input type="number" min="1" class="w-commerce-commerceaddtocartquantityinput quantity" value="1">
            <button style="margin-top: 40px" @click="secureNow(productData)" class="w-commerce-commerceaddtocartbutton button-3">{{buttonText}}</button>
          </form>
          <div class="w-commerce-commerceaddtocartoutofstock" style="display: none;">
            <div>This product is out of stock.</div>
          </div>
          <div class="w-commerce-commerceaddtocarterror" style="display: none;">
            <div class="w-add-to-cart-error-msg">Product is not available in this quantity.</div>
          </div>
        </div>
      </div>
    </div>
    <div class="div-block-13 img"><img :src="productImage" alt="" class="image-8"></div>
  </div>
</body>
</template>
<script>
import { productService } from '@/services/product'
import {checkoutService} from '@/services/checkout'
export default {
  computed: {
    profiles() {
      return this.$store.state.profiles.profiles
    },
    productImage() {
      let {
        productData
      } = this
      if (productData && productData.productImage) {
        return productData.productImage
      } else {
        return null
      }
    },
    realSize() {
      let { selectedSize } = this
      if (!selectedSize && this.productData.sizeType == 'OS') return 'OS'
      return selectedSize
    },
    styles() {
      if (this.productData && this.productData.styles) {
        let split = this.productData.styles.split(',')
        if (split && split.length > 0) {
          return split
        } else {
          return [{ text: 'One Style', value: 'OS' }]
        }

      } else {
        return [{ text: 'One Style', value: 'OS' }]
      }
    },

  },
  data() {
    return {
      productId: this.$route.query.productId,
      productData: {},
      products: [],
      selectedSize: null,
      selectedStyle: null,
      buttonText: 'Secure Now'
    }
  },
  async created() {
    await this.setProduct()
    if (this.styles[0]) {
      this.selectedStyle = this.styles[0].value || this.styles[0]
    }
    this.$store.dispatch('profiles/getProfiles')
  },
  methods: {
    async setProduct() {
      let products = await productService.getAvailProducts()
      this.products = products
      let targetProduct = products.find(p => p.productId == this.productId)
      if (!targetProduct) return console.log(`no product found`)
      this.productData = targetProduct
    },
    secureNow(product) {
      console.log(`secureNow called`)
      let { realSize, selectedStyle } = this
      if (!realSize && !selectedStyle) return console.log(`no size selected`)
      this.buttonText = 'Securing...'
      if(!this.profiles || !this.profiles[0] || !this.profiles[0].profileId) return console.error(`no profiles / error loading`)
      let profileId = this.profiles[0].profileId
      console.log(`checking out slot for product ${product.productTitle} with profile ${profileId} and size ${this.realSize} and style ${selectedStyle}`)
      let checkoutPayload = {productId: product.productId,style: selectedStyle, size: realSize,profileId}
      checkoutService.withProfile(checkoutPayload)
      .then(resp => {
        let {order} = resp
        let orderId
        if(order) orderId = order.orderId
        console.log(`order ${orderId} placed!`)
        this.buttonText = 'Secured.'
	      gtag('event','purchase', {
		      "transaction_id": orderId,
		      value: order.price,
		      currency: 'USD',
		      "items": [
			      {
				      id: order.productId,
				      name: order.productTitle,
				      price: order.price
			      }
		      ]
	      })
        setTimeout(() => {
          this.buttonText = 'Redirecting...'
          setTimeout(() => {
            this.$router.push('/dashboard')
          },2000)
        },2000)
      })
      .catch(e => {
        console.error(e)
        this.buttonText = 'Error. Refresh.'
      })

      /* we are live faggot
      setTimeout(() => {
        this.buttonText = 'Secured!'
        setTimeout(() => {
          this.buttonText = 'Redirecting...'
        }, 2500)
      }, 2000) */

    },
  }
}
</script>
